import type { ResolvedExtendedSchemaObject } from "@/services/open-api/openApi.types";

function hasOwnSchemaKey(schema: ResolvedExtendedSchemaObject | null | undefined, key: string): boolean {
  return Boolean(schema && Object.prototype.hasOwnProperty.call(schema, key));
}

export function isExcelReadOnlyField(path: string, schema?: ResolvedExtendedSchemaObject | null): boolean {
  const hasReadOnlyPath = path.split(".").some((segment) => segment === "unit_system");

  if (hasReadOnlyPath) {
    return true;
  }

  if (!schema) {
    return false;
  }

  if (hasOwnSchemaKey(schema, "const") || schema.readOnly === true) {
    return true;
  }

  return schema.style?.disabled === true;
}
